import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';
import { linkFieldviewAccount } from '/@/store/session/actions';
import ImportFields from './import-fields';

const LinkWithFieldviewStep = ({
    onClose,
    bodyProps,
    actionsProps,
    open,
}: {
    onClose: () => void;
    bodyProps?: React.ComponentProps<typeof ModalV2>['bodyProps'];
    actionsProps?: React.ComponentProps<typeof ModalV2>['actionsProps'];
    open: boolean;
}) => {
    const dispatch = useDispatch();
    const [state, setState] = useState<'initial' | 'success' | 'error'>('initial');
    const [fieldviewId, setFieldviewId] = useState<number | null>(null);

    const linkFieldview = useCallback(() => {
        dispatch(
            linkFieldviewAccount({
                source: 'new-field',
                onSuccess: (data: { fieldview_id?: unknown }) => {
                    setState('success');
                    const fvId = data?.fieldview_id;
                    setFieldviewId(fvId != null ? Number(fvId) : null);
                },
                onError: () => {
                    setState('error');
                },
            })
        );
    }, [dispatch]);

    useEffect(() => {
        if (state === 'initial') {
            linkFieldview();
        }
    }, [state, linkFieldview]);

    return (
        <>
            {state === 'initial' && (
                <ModalV2
                    open={open}
                    onClose={onClose}
                    title={_('Conectar con FieldView')}
                    actions={
                        <>
                            <Button
                                variant='text'
                                color='secondary'
                                onClick={() => {
                                    onClose();
                                }}
                            >
                                {_('Cancelar')}
                            </Button>
                            <Button variant='contained' color='secondary' onClick={() => linkFieldview()}>
                                {_('Volver a abrir ventana')}
                            </Button>
                        </>
                    }
                    bodyProps={bodyProps}
                    actionsProps={actionsProps}
                    maxWidth='sm'
                >
                    <Typography variant='subtitle1' color='primary'>
                        {_('Estamos redirigiéndote a Fieldview para iniciar sesión y sincronizar tus lotes.')}
                    </Typography>
                    <Typography variant='body1' color='primary'>
                        {_('Si no ves la ventana de inicio, podés reabrirla.')}
                    </Typography>
                </ModalV2>
            )}
            {state === 'success' && fieldviewId != null && (
                <ImportFields
                    open={open}
                    onClose={onClose}
                    bodyProps={bodyProps}
                    actionsProps={actionsProps}
                    fieldviewId={String(fieldviewId)}
                    onImportSuccess={() => {
                        onClose();
                        enqueueSnackbar(_('Los lotes de FieldView se importaron exitosamente.'), {
                            variant: 'success',
                        });
                    }}
                />
            )}
            {state === 'error' && (
                <ModalV2
                    open={open}
                    onClose={onClose}
                    title={_('Error al conectar con FieldView')}
                    actions={
                        <>
                            <Button variant='text' color='secondary' onClick={onClose}>
                                {_('Cancelar')}
                            </Button>
                            <Button variant='contained' color='secondary' onClick={() => linkFieldview()}>
                                {_('Reintentar')}
                            </Button>
                        </>
                    }
                    bodyProps={bodyProps}
                    actionsProps={actionsProps}
                    maxWidth='sm'
                >
                    <Typography variant='subtitle1' color='primary'>
                        {_('Hubo un error al intentar conectar con FieldView. Por favor, intentá nuevamente.')}
                    </Typography>
                </ModalV2>
            )}
        </>
    );
};

export default LinkWithFieldviewStep;
